// Sign-up details waiting for the account to exist: company, phone, the two consents
// (and the name, for email sign-ups). Saved just before the account is created, by email
// or Google, and sent with every /firebase-login call until one succeeds. Creating the
// Firebase account fires App.jsx's auth listener before the sign-up form's own call, so
// whichever call creates the user row carries them.

const KEY = 'realtorch.pendingSignup';
const MAX_AGE_MS = 30 * 60 * 1000;

// Effective date of https://www.realtorch.ai/terms, recorded with the acceptance.
export const TERMS_VERSION = '2026-03-12';
export const TERMS_URL = 'https://www.realtorch.ai/terms';
export const PRIVACY_URL = 'https://www.realtorch.ai/privacy';

export function savePendingSignup({ name, email, companyName, phone, acceptedTerms, acceptedEstimates }) {
  try {
    sessionStorage.setItem(KEY, JSON.stringify({
      name: name || '',
      email: (email || '').trim().toLowerCase(),
      company_name: companyName || '',
      phone: phone || '',
      accepted_terms: Boolean(acceptedTerms),
      accepted_estimates: Boolean(acceptedEstimates),
      terms_version: TERMS_VERSION,
      saved_at: Date.now(),
    }));
  } catch {
    // Storage blocked: the form's own /firebase-login call still sends the details.
  }
}

export function clearPendingSignup() {
  try { sessionStorage.removeItem(KEY); } catch { /* nothing to clear */ }
}

// The pending details for this Firebase user, or null. An email sign-up only matches its
// own email; a Google sign-up (email unknown until Google answers) matches whoever signs in.
export function pendingSignupFor(firebaseUser) {
  let pending = null;
  try {
    pending = JSON.parse(sessionStorage.getItem(KEY) || 'null');
  } catch {
    return null;
  }
  if (!pending || Date.now() - (pending.saved_at || 0) > MAX_AGE_MS) {
    clearPendingSignup();
    return null;
  }
  const email = (firebaseUser?.email || '').toLowerCase();
  if (pending.email && pending.email !== email) return null;
  return pending;
}

// The `signup` object /firebase-login stores (website/services/signup_details.py).
export function signupPayload(pending) {
  if (!pending) return undefined;
  return {
    company_name: pending.company_name || null,
    phone: pending.phone || null,
    accepted_terms: Boolean(pending.accepted_terms),
    accepted_estimates: Boolean(pending.accepted_estimates),
    terms_version: pending.terms_version || TERMS_VERSION,
  };
}
